/**
 * 静态 FAQ / Blog 站路径（/{lang}/index.html）与官网 i18n locale 的映射。
 * 官网用 zh，静态站中文目录是 cn；其余与 locale 同名。
 * 未覆盖的语言回退到 en。
 */
const FAQ_LOCALE_ALIAS = {
  zh: 'cn',
}

const FAQ_SUPPORTED_LOCALES = new Set([
  'cn',
  'en',
  'ru',
  'ja',
  'fr',
  'ko',
  'ar',
  'th',
  'vi',
  'bg',
  'es',
])

export function getFaqSiteLocale(locale) {
  const raw = String(locale || localStorage.getItem('language') || 'en').toLowerCase()
  const mapped = FAQ_LOCALE_ALIAS[raw] || raw
  return FAQ_SUPPORTED_LOCALES.has(mapped) ? mapped : 'en'
}

export function getFaqHref(locale) {
  return `/${getFaqSiteLocale(locale)}/index.html`
}
